import { render, staticRenderFns } from "./AssetApprovalFilters.vue?vue&type=template&id=23a34134&scoped=true"
import script from "./AssetApprovalFilters.vue?vue&type=script&lang=js"
export * from "./AssetApprovalFilters.vue?vue&type=script&lang=js"
import style0 from "./AssetApprovalFilters.vue?vue&type=style&index=0&id=23a34134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a34134",
  null
  
)

export default component.exports